import { RefreshCw, Search } from "lucide-react";
import { Button } from "../../../components/button";
import { Input } from "../../../components/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/select";
import {
  CAMPAIGN_STATUS_LABELS,
  CAMPAIGN_STATUS_OPTIONS,
} from "../types/campaign-status.constants";

interface CampaignFiltersProps {
  loading: boolean;
  searchTerm: string;
  statusFilter: string;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onRetry: () => void;
}

export function CampaignFilters({
  loading,
  searchTerm,
  statusFilter,
  onSearchChange,
  onStatusChange,
  onRetry,
}: CampaignFiltersProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-1 flex-col gap-3 md:flex-row">
        <Input
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Search campaigns, programs, opportunities..."
          startIcon={<Search className="h-4 w-4 text-[#6B7280]" />}
          className="h-11 flex-1 rounded-[10px] border-[#E2E8F0] bg-white"
        />
        <Select
          value={statusFilter}
          onValueChange={onStatusChange}
        >
          <SelectTrigger className="h-11 w-full rounded-[10px] border-[#E2E8F0] md:w-[180px]">
            <SelectValue placeholder="All statuses" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            {CAMPAIGN_STATUS_OPTIONS.map((option) => (
              <SelectItem
                key={option}
                value={option}
              >
                {CAMPAIGN_STATUS_LABELS[option]}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <Button
        variant="outline"
        onClick={onRetry}
        className="h-11 rounded-[10px] border-[#D5DDE7] px-4 text-[#004232]"
      >
        <RefreshCw className={`mr-2 h-4 w-4${loading ? " animate-spin" : ""}`} />
        Retry
      </Button>
    </div>
  );
}
